import { FC } from 'react';

import { useNavigate } from 'react-router-dom';

import Meta from '@bizapp-lp/workflow/organisms/Meta';
import HomeTemplate, {
  HomeProps as HomeTemplateProps,
} from '@bizapp-lp/workflow/templates/Home';
const title = 'Workflow | 株式会社ワークスアプリケーションズ・エンタープライズ';
const description =
  '株式会社ワークスアプリケーションズ・エンタープライズがご提供する、Workflowのページです。';

const Home: FC = () => {
  const navigate = useNavigate();

  const homeTemplateProps: HomeTemplateProps = {
    faq: {
      questions: [
        {
          id: 'q1',
          question:
            'Workflowにアップロードできるファイル容量に制限はありますか？',
          answer: (
            <p>
              <span>「契約ライセンス数×3GB」の容量制限がございます。</span>
              <span>容量制限は全ユーザーで利用できる総量となります。</span>
              <span>
                契約ライセンス数が100の場合、300GBを全ユーザーでシェアします。
              </span>
            </p>
          ),
        },
        {
          id: 'q2',
          question: 'サポート体制はどうなっていますか？',
          answer: (
            <p>
              <span>
                お問い合わせについては、メールサポートをご用意しております。
              </span>
              <span>
                ご質問には、3営業日をめどに（土日祝日、年末年始を除く）に１次回答いたします。
              </span>
            </p>
          ),
        },
        {
          id: 'q3',
          question: '導入にはどれくらい時間がかかりますか？',
          answer: (
            <p>
              お申込みをいただいてから1週間程度で、お客様専用の環境を準備し、管理者アカウントを発行します。アカウントを受け取られたら、その日から利用開始いただけます。
            </p>
          ),
        },
        {
          id: 'q4',
          question: 'サービスの利用に必要なものは何ですか？',
          answer: (
            <>
              <p>
                インターネット環境と推奨ブラウザを利用できるパソコンが必要です。導入に際してサーバーの準備等は必要ありません。
              </p>
              <p>
                <span>推奨ブラウザ：</span>
                <span>Google Chrome 最新の安定バージョン(*1)</span>
                <span>Microsoft Edge 最新の安定バージョン(*1)</span>
              </p>
              <p>
                (*1)大型Updateの際、内容により
                アプリケーションの動作に影響を与える場合があります。
                弊社検証にて影響が確認された場合は、利用を控えていただく案内をいたします。
              </p>
              <ul>
                <li>
                  ベンダーのサポートが終了しているものについては予告なくサポートを終了します。
                </li>
                <li>
                  Microsoft Edge は、米国Microsoft Corporation
                  の米国およびその他の国における登録商標です。
                </li>
                <li>Google Chrome は、Google Inc. の商標です。</li>
              </ul>
            </>
          ),
        },
        {
          id: 'q5',
          question:
            '無料トライアルでできること、その後の有料契約への流れについて教えてください。',
          answer: (
            <p>
              <span>ご利用者様20名まで、30日間無料でご利用いただけます。</span>
              <span>
                無料トライアル終了後、自動的には有料契約へ切り替わりません。ご希望される場合は弊社までご連絡ください。
              </span>
              <span>
                無料トライアル終了後に有料契約移行のお申し入れがない場合は、弊社でトライアル時のデータを破棄して終了となります。
              </span>
            </p>
          ),
        },
        {
          id: 'q6',
          question: '決済方法や請求のタイミングを教えてください。',
          answer: (
            <p>
              <span>
                銀行振込と口座引落がご利用いただけます。※請求はマネーフォワードケッサイ株式会社による「マネーフォワード
                ケッサイ」サービスにて行われます。
              </span>
              <span>
                請求は月末締め翌月末払いとなり、毎月末時点の契約ライセンス数に応じて翌月1日より1ヶ月分の費用が発生します。
              </span>
            </p>
          ),
        },
        {
          id: 'q7',
          question: '有料プランの更新や解約について教えてください。',
          answer: (
            <p>
              <span>
                有料プラン契約は、解約のお申し出がない限り毎月自動更新されます。
              </span>
              <span>
                解約はいつでも可能で、解約のご申請をいただいてから1か月後または解約を希望する日のいずれか遅い日を解約日とし、解約をすることができます。なお、解約日から月末までの利用料金も発生します。
              </span>
            </p>
          ),
        },
      ],
    },
    plan: {
      onClick1: () => navigate('/workflow/document-claim'),
      onClick2: () => navigate('/workflow/contact'),
    },
    closing: {
      onClick1: () => navigate('/workflow/document-claim'),
      onClick2: () => navigate('/workflow/contact'),
    },
  };

  return (
    <>
      <Meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Meta>
      <HomeTemplate {...homeTemplateProps} />
    </>
  );
};

export default Home;
